<template>
  <!-- Matches the sidebar set: 21x21 box, 1.64px stroke outline / solid fill when selected. -->
  <svg v-if="!isFilled"
       xmlns="http://www.w3.org/2000/svg"
       width="21"
       height="21"
       viewBox="0 0 21 21"
       class="fill-current"
  >
    <path
      d="M13.02 1.64a5.32 5.32 0 0 0-4.7 7.83L1.8 15.99a1.9 1.9 0 0 0 2.69 2.69l6.52-6.52a5.32 5.32 0 0 0 6.87-6.94l-2.9 2.9-2.6-.65-.65-2.6 2.9-2.9a5.3 5.3 0 0 0-1.61-.33Z"
      style="fill:none;fill-rule:nonzero;stroke:currentColor;stroke-width:1.64px;stroke-linejoin:round;"
    />
  </svg>

  <svg v-else
       xmlns="http://www.w3.org/2000/svg"
       width="21"
       height="21"
       viewBox="0 0 21 21"
       class="fill-current"
  >
    <path
      d="M13.02 1.64a5.32 5.32 0 0 0-4.7 7.83L1.8 15.99a1.9 1.9 0 0 0 2.69 2.69l6.52-6.52a5.32 5.32 0 0 0 6.87-6.94l-2.9 2.9-2.6-.65-.65-2.6 2.9-2.9a5.3 5.3 0 0 0-1.61-.33Z"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  props: {
    isFilled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
